import React, { useState, useEffect } from 'react';
import NotificationsBoard from './notifications/NotificationsBoard';
import PlaceHolderBoard from './placeholder/PlaceHolderBoard';
import CookieMainMenu from './cookies/CookieMainMenu';
import UserBoard from './users/UserBoard';
import TimeSheetBoard from './timesheet/TimeSheetBoard';
import logo from './img/logo.svg';
import './css/App.css';
import './css/bootstrap.min.css';
import bootstrap from 'bootstrap';

class DashBoard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			user: this.props.user,
			permissions: this.props.permissions
		};
	}

	componentDidMount() {
		document.title = this.props.user + "'s Dashboard";
		this.getIpHostname();
	}

	/**
	 * Here we make an API request to get the Hostname of the user's internet provider
	 * if the result is different that we expected so it will be considered a remote work location
	 */
	getIpHostname = async () => {

		let ipHostname;

		await fetch("https://ipinfo.io/99.252.136.144?token=a4930ec22d1764")
			.then(response => response.json())
			.then(result => ipHostname = result.hostname)
			.catch(error => console.log('error', error));

		console.log(ipHostname)

		if (ipHostname == 'cpef81d0f851093-cmf81d0f851090.sdns.net.rogers.com') {
			localStorage.setItem('location', 'Office');
		} else {
			localStorage.setItem('location', 'Remote');
		}

	}

	render() {
		return (
			<div className='container-fluid'>
				<div className='row'>
					<div className='col60 p-1'>
						<NotificationsBoard user={this.props.user} />
					</div>
					<div className='col20 p-1'>
						<UserBoard user={this.props.user} />
					</div>
					<div className='col20 p-1'>
						<TimeSheetBoard user={this.props.user} />
					</div>
					<div className='col20 p-1'>
						<PlaceHolderBoard title="Promoter" />
					</div>
					<div className='col20 p-1'>
						<PlaceHolderBoard title="T-Rex" />
					</div>
					<div className='col20 p-1'>
						<CookieMainMenu title="Cookie" />
					</div>
					<div className='col20 p-1'>
						<PlaceHolderBoard title="Main" />
					</div>
					<div className='col20 p-1'>
						<PlaceHolderBoard title="Chugger" />
					</div>
				</div>
			</div>
		);
	}
}

export default DashBoard;